/**
 * Theme registry.
 *
 * Add a new theme by:
 *   1. Adding a `[data-theme="<name>"]` token block in `styles/tokens.css`.
 *   2. Registering it here.
 *   3. Optionally picking it as the default below.
 *
 * No application code needs to change — every consumer reads the active theme
 * from the same `ThemeProvider`.
 */

export type ThemeName = "light" | "dark" | "clay";

export interface ThemeDefinition {
  /** Value written to the `data-theme` attribute / document class. */
  id: ThemeName;
  /** Human-friendly label shown in a theme picker. */
  label: string;
  /** Set of icon-ish emoji/char shown in a picker; purely cosmetic. */
  swatch: string;
  /** Base appearance, used to resolve light/dark-aware UI decisions. */
  appearance: "light" | "dark";
}

export const THEMES: ThemeDefinition[] = [
  { id: "dark", label: "Ito Ink", swatch: "◐", appearance: "dark" },
  { id: "light", label: "Ito Paper", swatch: "○", appearance: "light" },
  { id: "clay", label: "Clay", swatch: "◍", appearance: "light" },
];

export const DEFAULT_THEME: ThemeName = "dark";

export const STORAGE_KEY = "ito.theme";

export const isTheme = (value: string | null | undefined): value is ThemeName =>
  !!value && THEMES.some((theme) => theme.id === value);
